import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import RegistryContext, { createRegistry } from './RegistryContext';
import DistractionFreeModeContext from '../DistractionFreeModeContext';
import { toToolbarItems } from './ToolbarItem';
import Squeezer from '../Squeezer';

/**
 * `Toolbar` component is a panel containing various instruments used for managing the contents of a large content block.
 * Toolbar is located on top of the managed content block.
 * It typically consists of three main parts: controls that add new elements, controls that work with existing elements,
 * and controls for changing the way the content block looks.
 * @since 0.0.57
 */
var Toolbar =
/*#__PURE__*/
function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar(props) {
    var _this;

    _classCallCheck(this, Toolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      distractionFreeMode: {
        enabled: false,
        toggle: function toggle() {
          _this.setState(function (prevState) {
            return {
              distractionFreeMode: _objectSpread({}, prevState.distractionFreeMode, {
                enabled: !prevState.distractionFreeMode.enabled
              })
            };
          }, function () {
            _this.measure();
          });
        }
      }
    });

    _this.registry = createRegistry();

    _this.measure = function () {};

    return _this;
  }

  _createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "children"]);

      var toolbarItems = toToolbarItems(children);
      return React.createElement(Squeezer, {
        compact: function compact() {
          return _this2.registry.compact();
        },
        uncompact: function uncompact() {
          return _this2.registry.uncompact();
        },
        innerMeasure: function innerMeasure(measure) {
          _this2.measure = measure;
        }
      }, function (_ref) {
        var ref = _ref.ref;
        return React.createElement("div", _extends({
          ref: ref,
          className: classNames(baseClassName, className)
        }, props), React.createElement(RegistryContext.Provider, {
          value: _this2.registry
        }, React.createElement(DistractionFreeModeContext.Provider, {
          value: _this2.state.distractionFreeMode
        }, toolbarItems)));
      });
    }
  }]);

  return Toolbar;
}(Component);

Toolbar.propTypes = {
  /**
   * Content of the `Toolbar`.
   * @since 0.0.57
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Toolbar.defaultProps = {
  children: null,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "toolbar")
};
export default Toolbar;